import type { MarketingBannerRow } from "../MarketingBanners/types";

import { CardMeta } from "./CardMeta";
import { CardThumbnail } from "./CardThumbnail";

export type MarketingCardProps = {
  banner: MarketingBannerRow;
  title: string;
  languages: string[];
  sizes: string[];
  tags: string[];
  /** Locale-aware label for the unknown-asset fallback (defaults to English). */
  unknownAssetLabel?: string;
  onConfigure?: () => void;
  /** Fired when the language list's hover tooltip opens. */
  onLanguagesTooltipOpen?: () => void;
  /** Fired when the size list's hover tooltip opens. */
  onSizesTooltipOpen?: () => void;
};

export function MarketingCard({
  banner,
  title,
  languages,
  sizes,
  tags,
  unknownAssetLabel,
  onConfigure,
  onLanguagesTooltipOpen,
  onSizesTooltipOpen,
}: MarketingCardProps) {
  return (
    <div
      className="flex flex-col gap-4 rounded-lg bg-white"
      data-name="marketing-card"
    >
      <CardThumbnail
        banner={banner}
        unknownAssetLabel={unknownAssetLabel}
        onConfigure={onConfigure}
      />
      <CardMeta
        title={title}
        languages={languages}
        sizes={sizes}
        tags={tags}
        onLanguagesTooltipOpen={onLanguagesTooltipOpen}
        onSizesTooltipOpen={onSizesTooltipOpen}
      />
    </div>
  );
}
